module.exports = __webpack_public_path__ + "static/media/github-background.fe82ec00.svg";